export default class StockAgeRuleModel {
    creationTime?: Date;
    updateTime?: Date;
    name: string;
    storeName: string;
    storeId: number;
    cube: number;
    singleCube: number;
    userList: string;
    id: number;
    items: Array<StockAgeRuleItemModel>;
}

class StockAgeRuleItemModel {
    begin: number;
    end: number;
    maxCost?: number;
    cost: number;
}